import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormFieldModule, InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from '@progress/kendo-angular-label';

import { QueryPanelConnectorService } from 'src/app/modules/fwcore/services';

@Component({
  selector: 'criteria-container',
  styleUrls: ['./criteria-container.component.scss'],
  templateUrl: './criteria-container.component.html',
  standalone: true,
  imports: [
    InputsModule, LabelModule, ReactiveFormsModule]
})

export class CriteriaContainerComponent {
  /*-------------------------- Input / Outputs --------------------------------*/

  @Output() onChange = new EventEmitter();

  /*-------------------------- public properties / methods --------------------*/

  /*-------------------------- public methods ------------------------*/

  public treeviewContainerForm: FormGroup = new FormGroup({
    filterBox: new FormControl()
  });

  /*-------------------------- Internal properties  ------------------*/

  protected filterValue: string = "";
  protected interval: any;
  protected isFilterFocus: boolean = false;

  /*-------------------------- Constructor  --------------------------*/
  constructor (protected connectorService: QueryPanelConnectorService) {}

  /*-------------------------- Event handlers --------------------------*/

  onFilterChange(value: string) {
    this.filterValue = value;
  }

  onFilterInputBlur() {
    this.isFilterFocus = false;
  }

  onFilterInputFocus() {
    this.isFilterFocus = true;
  }

  /*-------------------------- Host listeners --------------------------*/

  // Keyboard event: handles the "press enter to search" because Telerik
  // doesn't give us a keypress event for the kendoTextBox.
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.isFilterFocus && event.key == "Enter") {
      this.connectorService.filter(this.filterValue);
    }
  }
}
